import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LinkGlyph = /*#__PURE__*/createElement("g", {
  id: "link"
}, /*#__PURE__*/createElement("path", {
  d: "M27.84 65.14c-2.51 0-4.77-.89-6.43-2.56-3.86-3.86-3.27-10.73 1.32-15.31l8.51-8.51c2.18-2.18 4.94-3.54 7.78-3.82 2.95-.3 5.62.59 7.53 2.5.59.59.59 1.54 0 2.12-.59.59-1.54.59-2.12 0-1.26-1.26-3.08-1.84-5.11-1.64-2.15.21-4.27 1.26-5.96 2.96l-8.51 8.51c-3.41 3.42-4.01 8.38-1.32 11.07 1.26 1.26 3.08 1.84 5.11 1.64 2.15-.21 4.26-1.26 5.96-2.96l5.6-5.6c.59-.59 1.54-.59 2.12 0s.59 1.54 0 2.12l-5.6 5.6c-2.18 2.18-4.94 3.54-7.78 3.82-.38.05-.74.06-1.1.06z"
}), /*#__PURE__*/createElement("path", {
  d: "M43.88 49.1c-2.51 0-4.77-.89-6.44-2.56-.59-.59-.59-1.54 0-2.12s1.54-.59 2.12 0c1.26 1.26 3.07 1.84 5.11 1.64 2.15-.21 4.26-1.26 5.96-2.96l8.51-8.51c3.42-3.42 4.01-8.38 1.32-11.07-2.69-2.69-7.65-2.1-11.07 1.32l-5.6 5.6c-.59.59-1.54.59-2.12 0a1.49 1.49 0 010-2.12l5.6-5.6c4.58-4.59 11.45-5.18 15.31-1.32 1.91 1.91 2.8 4.58 2.5 7.53-.28 2.84-1.64 5.6-3.82 7.78l-8.51 8.51c-2.18 2.18-4.94 3.54-7.78 3.82-.36.04-.73.06-1.09.06z"
}));
const Link = createSvg({
  name: 'link',
  path: LinkGlyph
});

export default Link;
export { LinkGlyph };
